import { ButtonGroup, Divider, Td, Tr } from "@chakra-ui/react";
import { Breadcrumb, Container, Form, Heading, IconButton, Profile, Row, Searchable, Table, Tag } from "components";
import { Mask } from "config";
import { Moment } from "config";
import { useIdentity } from "hooks";
import { useState } from "react";
import { useNavigate } from "react-router";

export default function Identity(){

    const [ term, setTerm ] = useState()
    const [ status, setStatus ] = useState()
    const [ page, setPage ] = useState()
    const list = useIdentity(page, term, status)

    const columns = [{ children: 'Consultor' }, { children: 'CPF', isNumeric: true }, { children: 'Status' }, { children: 'Data do Cadastro', isNumeric: true }]

    return(
    <Container>
        
        <Breadcrumb prev={{ path: '/tools', label: 'Ferramentas' }} current="Verificação de identidade" />

        <Heading title="Verificação de identidade">
            <ButtonGroup size="xs" isDisabled={list.isFetching}>
                <IconButton label="Atualizar" icon="refresh" isLoading={list.isFetching} onClick={list.refetch} />
            </ButtonGroup>
        </Heading>

        <Divider my={4} />

        <Searchable placeholder="Procurar por id, código, nome ou cpf..." value={term} setValue={setTerm}>
            {/* <Form.Select value={status} onChange={e => setTerm(e.target.value)} options={[{ label: 'Documento enviado', value: 1 }, { label: 'Aguardando envio', value: 2 }]} /> */}
        </Searchable>

        <Table columns={columns} mt={4} setPage={setPage} meta={list.data?.meta}>
            { list.data?.data?.map(item => <Item key={item.id} data={item} />)}
        </Table>

    </Container>
    )
}

const Item = ({ data }) => {
    
    const navigate = useNavigate()

    return(
    <Row onClick={() => navigate(`/consultants/${data.consultant.id}`)}>
        <Td><Profile name={data.name} /></Td>
        <Td isNumeric>{Mask.cpf(data.doc_cpf)}</Td>
        <Td><Tag children="Identidade não verificada" colorScheme="red" /></Td>
        <Td isNumeric>{Moment(data.created_at).fromNow()}</Td>
    </Row>
    )
}